<template>
  <div v-if="isLoading" class="loader-overlay">
    <div class="loader-content">
      <img src="/img/logo.png" alt="Loading Logo" class="pulse-logo" />
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "GlobalLoader",
  setup() {
    const store = useStore();
    const isLoading = computed(() => store.getters["loader/isLoading"]);

    return {
      isLoading,
    };
  },
};
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pulse-logo {
  height: 80px;
  width: auto;
  animation: pulseLogo 1.5s infinite ease-in-out;
  z-index: 10;
}

.spinner {
  position: absolute;
  width: 140px;
  height: 140px;
  border: 4px solid transparent;
  border-top-color: #2c3e50; /* Adjust to match the logo/brand color */
  border-right-color: #3498db; 
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulseLogo {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
}
</style>
